import Swiper from 'swiper';
import {
    Navigation,
    A11y,
    Mousewheel,
    Keyboard,
    FreeMode,
    EffectFade,
    Autoplay
} from 'swiper/modules';

// News slider
document.querySelectorAll('.swiperNewsSlider').forEach(function (slider) {
    const container = slider.closest('.swiperNewsBlock');
    const nextButtons = Array.from(container.querySelectorAll('.swiperNewsNext'));
    const prevButtons = Array.from(container.querySelectorAll('.swiperNewsPrev'));
    const buttonWrap = container.querySelector('.slider-button-wrap');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y, Mousewheel, Keyboard, FreeMode],
        grabCursor: true,
        a11y: { enabled: true },
        lazy: true,
        freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
        },
        mousewheel: {
            enabled: true,
            forceToAxis: true,
            sensitivity: 0.5,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: false,
        },
        navigation: {
            nextEl: nextButtons,
            prevEl: prevButtons,
        },
        breakpoints: {
            0: { slidesPerView: 1.1, spaceBetween: 16 },
            576: { slidesPerView: 1.75, spaceBetween: 16 },
            992: { slidesPerView: 2.1, spaceBetween: 16 },
            1200: { slidesPerView: 2.5, spaceBetween: 16 },
        },
        on: {
            init(swiper) {
                if (swiper.slides.length <= 1 && buttonWrap) {
                    buttonWrap.style.display = 'none';
                }
            }
        }
    });
});

// Testimonials slider
document.querySelectorAll('.swiperTestimonialsSlider').forEach(function (slider) {
    const gradientWrap = slider.closest('.swiperTestimonialsWrap');
    const container = slider.closest('.swiperTestimonialsBlock');
    const nextButtons = Array.from(container.querySelectorAll('.swiperTestimonialsNext'));
    const prevButtons = Array.from(container.querySelectorAll('.swiperTestimonialsPrev'));
    const buttonWrap = container.querySelector('.slider-button-wrap');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y, Mousewheel, Keyboard, FreeMode],
        grabCursor: true,
        a11y: { enabled: true },
        lazy: true,
        freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
        },
        mousewheel: {
            enabled: true,
            forceToAxis: true,
            sensitivity: 0.5,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: false,
        },
        navigation: {
            nextEl: nextButtons,
            prevEl: prevButtons,
        },
        breakpoints: {
            0: { slidesPerView: 1.1, spaceBetween: 16 },
            576: { slidesPerView: 1.75, spaceBetween: 16 },
            992: { slidesPerView: 2.1, spaceBetween: 24 },
            1200: { slidesPerView: 2.5, spaceBetween: 24 },
        },
        on: {
            init(swiper) {
                if (swiper.slides.length <= 1 && buttonWrap) {
                    buttonWrap.style.display = 'none';
                }
                if (swiper.isBeginning) gradientWrap.classList.add('__at-start');
                if (swiper.isEnd) gradientWrap.classList.add('__at-end');
            },
            reachBeginning() {
                gradientWrap.classList.add('__at-start');
            },
            reachEnd() {
                gradientWrap.classList.add('__at-end');
            },
            fromEdge() {
                gradientWrap.classList.remove('__at-start', '__at-end');
            }
        }
    });
});

// Info slider
document.querySelectorAll('.swiperInfoSlider').forEach(function (slider) {
    const container = slider.closest('.swiperInfoBlock');
    const nextButtons = Array.from(container.querySelectorAll('.swiperInfoNext'));
    const prevButtons = Array.from(container.querySelectorAll('.swiperInfoPrev'));
    const buttonWrap = container.querySelector('.slider-button-wrap');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y, Mousewheel, Keyboard, FreeMode, EffectFade],
        grabCursor: true,
        a11y: { enabled: true },
        lazy: true,
        effect: 'fade',
        loop: true,
        fadeEffect: {
            crossFade: true,
        },
        mousewheel: {
            enabled: true,
            forceToAxis: true,
            sensitivity: 0.5,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: false,
        },
        navigation: {
            nextEl: nextButtons,
            prevEl: prevButtons,
        },
        breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 16 },
        },
        on: {
            init(swiper) {
                if (swiper.slides.length <= 1 && buttonWrap) {
                    buttonWrap.style.display = 'none';
                }
            }
        }
    });
});

// Logo slider
document.querySelectorAll('.swiperLogoSlider').forEach(function (slider) {
    const gradientWrap = slider.closest('.swiperLogoWrap');
    const container = slider.closest('.swiperLogoBlock');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y, Mousewheel, Keyboard, FreeMode, Autoplay],
        grabCursor: true,
        a11y: { enabled: true },
        loop: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        },
        speed: 6000,
        breakpoints: {
            0: { slidesPerView: 2.5, spaceBetween: 16 },
            576: { slidesPerView: 4, spaceBetween: 16 },
            992: { slidesPerView: 5, spaceBetween: 24 },
            1200: { slidesPerView: 6.5, spaceBetween: 24 },
        },
    });
});
